<template>
  <div class="w-full p-4">
    <div class="relative">
      <div class="relative overflow-hidden">
        <NuxtImg
          src="/mask.png"
          alt="Background Image"
          title="Background Image"
          class="w-full rounded-2xl"
        >
          <h2
            class="absolute inset-0 flex items-center justify-center text-[#F0F2F3] font-inter text-[23px] ml-[80px] md:text-[30px] font-semibold leading-[32px]"
          >
            Important Update
          </h2>
        </nuxtimg>
      </div>
      <button
        class="absolute top-2 right-2 p-2 rounded-lg bg-[rgba(238,239,240,0.3)] text-white m-1.5"
        @click="closeModal"
      >
        <CloseIcon />
      </button>
    </div>
    <div
      v-if="data && data.length"
      class="pt-4"
    >
      <div class="flex items-center mb-3">
        <span
          class="flex items-center bg-[rgba(33,133,121,0.1)] text-green-800 text-sm font-semibold rounded mr-2 p-2.5"
        >
          <FireIcon :custom-style="`mr-1 h-4 w-4`" />
          <span class="text-base font-medium leading-6 text-center text-green-800 font-inter">New
            Feature</span>
        </span>
        <span class="text-sm text-gray-500">{{ formattedReleaseDate }}</span>
      </div>
      <h3 class="mb-2 text-2xl font-semibold leading-tight text-gray-900 font-inter">
        {{ data[0].feature_name }}
      </h3>

      <p class="text-opacity-60 font-inter text-base font-medium text-gray-700 leading-[31px] mb-6">
        {{ data[0].feature_description }}
      </p>
      <button
        class="text-white mt-10 px-4 py-2 h-14 rounded-lg hover:bg-[#218579] focus:outline-none focus:ring-2 focus:ring-green-500 w-full bg-[#218579] flex items-center justify-center"
        @click="navigateAndClose"
      >
        Assign asset class
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeatureDetail',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    linkTo: {
      type: String,
      default: '/',
    },
  },

  emits: ['close', 'after-close'],

  computed: {
    formattedReleaseDate() {
      if (this.data && this.data.length) {
        const date = new Date(this.data[0].feature_release_date)
        const options = { day: 'numeric', month: 'long', year: 'numeric' }
        return date.toLocaleDateString('en-GB', options)
      }
      return ''
    },
  },
  methods: {
    onLinkClick() {
      this.closeModal()
    },
    closeModal() {
      this.$emit('close')
      this.$parent.$emit('after-close')
    },
    navigateAndClose() {
      this.$router.push(this.linkTo)
      this.closeModal()
    },
  },
}
</script>
